import angular from 'angular';
import FavouriteStoreController from './favouriteStore.controller';

let favouriteStore = angular
    .module('favouriteStore', [])
    .controller('FavouriteStoreController', FavouriteStoreController);

export default favouriteStore;
